import React from 'react';
import { Tag } from 'lucide-react';

const PromoBanner: React.FC = () => {
  return (
    <div className="bg-gradient-to-r from-rose-600 via-pink-600 to-indigo-600 text-white py-2 px-4 relative z-50 shadow-lg border-b border-white/10">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
        <span className="flex items-center text-xs sm:text-sm font-bold tracking-wide uppercase bg-white/20 px-2 py-0.5 rounded">
          <Tag className="w-3 h-3 mr-1" />
          Holiday Sale
        </span>
        <p className="text-sm font-medium">
          Get <span className="font-extrabold text-white">50% OFF</span> any Annual Plan for a limited time.
        </p>
        <div className="hidden sm:block w-px h-4 bg-white/30"></div>
        <p className="text-sm font-mono bg-black/20 px-2 py-0.5 rounded border border-white/10">
          Code: <span className="font-bold text-amber-300">HOLIDAY50</span>
        </p>
      </div>
    </div>
  );
};

export default PromoBanner;